import React, { useState, useEffect } from 'react'
import { Checkbox, Input, Button, Dropdown } from 'antd'
import './styles.less'

const { Search } = Input

const getIds = (array, field) => {
  const ids = []
  array.forEach((element) => {
    ids.push(element[field])
  })
  return ids
}

const isSelected = (data, id) => !!data.find((item) => item === id)

const removeItem = (arr, item) => {
  const idx = arr.indexOf(String(item))
  if (idx > -1) {
    arr.splice(idx, 1)
  }
  return arr
}

const MultiSelect = ({
  icon = undefined,
  loading = false,
  disabled = false,
  dataSource = [],
  dataSelected = [],
  onChangeSelected,
  buttonText = 'Button Text',
  checkListTitle = 'Check All',
  searchText = 'Search',
  saveText = 'Save'
}) => {
  const [dataSourceFiltered, setDataSourceFiltered] = useState(dataSource)
  const [checkOptions, setCheckOptions] = useState({
    indeterminate: false,
    checkAll: false
  })
  const [selectedChecks, setSelectedChecks] = useState([])
  const [openSelect, setOpenSelect] = useState(false)

  useEffect(
    (_) => {
      setCheckAllOptions(dataSelected)
      setDataSourceFiltered(dataSource)
      setSelectedChecks(dataSelected)
      return () => {
        setCheckOptions({
          indeterminate: false,
          checkAll: false
        })
        setSelectedChecks(dataSelected)
        setOpenSelect(false)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataSource, dataSelected]
  )

  const iconComponent = () => {
    return icon ? icon : ''
  }

  const handleOpenSelect = (_) => {
    setOpenSelect(!openSelect)
  }

  const setCheckAllOptions = (selection) => {
    setCheckOptions({
      indeterminate: !!selection.length && selection.length < dataSource.length,
      checkAll: selection.length === dataSource.length
    })
  }

  const onChange = ({ target: { id, checked } }) => {
    let selection = selectedChecks
    if (checked) {
      selection.push(String(id))
    } else {
      selection = removeItem(selection, id)
    }
    setCheckAllOptions(selection)
    setSelectedChecks(selection)
  }

  const onCheckAllChange = ({ target: { checked } }) => {
    setCheckOptions({
      indeterminate: false,
      checkAll: checked
    })
    setSelectedChecks(checked ? getIds(dataSource, 'value') : [])
  }

  const filter = (value) => {
    setDataSourceFiltered(dataSource.filter(({ label }) => label.toLowerCase().indexOf(value.toLowerCase()) > -1))
  }

  const saveSelection = (_) => {
    onChangeSelected(selectedChecks)
    handleOpenSelect()
  }

  const multiSelect = (
    <div className='multi-select-open-view'>
      <div className='multi-select'>
        <div className='header'>
          <Checkbox
            indeterminate={checkOptions.indeterminate}
            onChange={onCheckAllChange}
            checked={checkOptions.checkAll}
            disabled={disabled}
          >
            {!checkOptions.checkAll && !checkOptions.indeterminate
              ? ` ${dataSource.length} ${checkListTitle}`
              : ` ${selectedChecks.length}/${dataSource.length} ${checkListTitle}`}
          </Checkbox>
        </div>
        <div className='container'>
          <div className='search'>
            <Search
              placeholder={searchText}
              onSearch={filter}
              onKeyDown={(e) => e.keyCode === 13 && e.preventDefault()}
            />
          </div>
          <div className='check-options'>
            <div className='checkbox-group'>
              {dataSourceFiltered.map(({ label, value }, idx) => {
                return (
                  <Checkbox
                    disabled={disabled}
                    key={idx}
                    id={String(value)}
                    onChange={onChange}
                    checked={isSelected(selectedChecks, value)}
                  >
                    {label}
                  </Checkbox>
                )
              })}
            </div>
          </div>
        </div>
        <div className='actions'>
          <Button disabled={!selectedChecks || selectedChecks.length === 0} onClick={saveSelection} type={'primary'}>
            {saveText}
          </Button>
        </div>
      </div>
    </div>
  )

  return (
    <div className='multi-select-component'>
      <Dropdown
        trigger={['click']}
        visible={openSelect}
        onClick={handleOpenSelect}
        overlay={multiSelect}
        className='multi-select-button'
      >
        <Button id='filter-multi-select' loading={loading}>
          {iconComponent()}
          {buttonText}
        </Button>
      </Dropdown>
    </div>
  )
}

export default MultiSelect
